import React from 'react'

const LinkExpiredBox = () => {
    return (
        <div className='flex flex-col gap-4'>
            <div className="text-3xl font-semibold text-center">
                This link has expired
            </div>
            <p className="mb-5 font-semibold text-center text-md ">Please contact your administrator <br /> to request another link</p>
            <div className="flex flex-col gap-4">
                <a href="/" className="flex items-center justify-center h-16 text-white transition-all rounded-md  bg-primary w-[27rem]"  >
                    Login
                </a>

            </div>
        </div>
    )
}

export default LinkExpiredBox